export default __webpack_public_path__ + "static/media/(31).77cd3867.JPG";